import React, { Component } from 'react';

import SvgIcon from '@material-ui/core/SvgIcon';

class CustomTooltip  extends Component{
    constructor(props){
        super(props);
        this.createIcon = this.createIcon.bind(this);
        this.state = {
            index: 0
        }
    }       
    
    createIcon(string, color) { 
        let cadena = string.toString().replace(/green/g, color);
        cadena = cadena.toString().replace(/#038bc0/g, color);
        cadena = cadena.toString().replace(/#0070a1/g, color);
        cadena = cadena.toString().replace(/#003951/g, color); 
        cadena = cadena.toString().replace(/#006290/g, color); 
        cadena = cadena.toString().replace(/#00629d/g, color); 
        cadena = cadena.toString().replace(/#1a171b/g, color);  
        cadena = cadena.toString().replace(/#646265/g, color);
        return {__html: cadena};
    };

    renderTooltip(){
        const {  payload, data, colors, svgs, total } = this.props; 
        
        var index = 0;
        for(let i=0; i<data.length; i++){            
            if(data[i].name === payload[0].name){ 
                index = i;                
                break;
            }
        } 
        
                       
        return (
            <div className="custom-tooltip">
                <p className="custom-tooltip-title" style={{color:colors[index%colors.length]}}>
                    <SvgIcon>
                        <svg dangerouslySetInnerHTML={this.createIcon(svgs[index%colors.length], colors[index%colors.length])} />
                    </SvgIcon>
                    {payload[0].name}
                </p>
                <p style={{color:colors[index%colors.length], fontSize:'13px'}}>
                    {payload[0].value + '/' + total}
                </p>
                <p style={{color:colors[index%colors.length], fontSize:'13px'}}>{((payload[0].value / total)*100).toFixed(0) + '%'}</p>            
            </div>
        )
    }
  
    render() {
        const { active } = this.props;
        if (active) {
            return (
                this.renderTooltip()
            )
        }  
        return null;
    }
}

export default CustomTooltip;